import { createSlice, PayloadAction } from "@reduxjs/toolkit";

type ClientProfile = {
  firstName: string;
  lastName: string;
  email: string;
  phone: string;
  id: string;
  createdAt: Date;
  avatarBase64?: string | null;
};

type AuthState = {
  clientProfile: ClientProfile | null;
  token: string | null;
  isAuthenticated: boolean;
};

const initialState: AuthState = {
  clientProfile: null,
  token: null,
  isAuthenticated: false,
};

export const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    setAuth: (state, action) => {
      const incoming = action.payload.profile;

      state.clientProfile = state.clientProfile
        ? { ...state.clientProfile, ...incoming }
        : incoming;

      state.token = action.payload.token;
      state.isAuthenticated = true;

      if (typeof window !== "undefined") {
        localStorage.setItem("client_token", action.payload.token);
        localStorage.setItem(
          "client_profile",
          JSON.stringify(state.clientProfile)
        );
      }
    },
    clearAuth: (state) => {
      state.clientProfile = null;
      state.token = null;
      state.isAuthenticated = false;

      if (typeof window !== "undefined") {
        localStorage.removeItem("client_token");
        localStorage.removeItem("client_profile");
      }
    },
    initializeAuth: (state) => {
      if (typeof window !== "undefined") {
        const token = localStorage.getItem("client_token");
        const profileData = localStorage.getItem("client_profile");

        if (token && profileData) {
          try {
            state.token = token;
            state.clientProfile = JSON.parse(profileData);
            state.isAuthenticated = true;
          } catch (e) {
            console.error("Failed to parse client profile", e);
          }
        }
      }
    },
    updateProfile: (state, action: PayloadAction<Partial<ClientProfile>>) => {
      if (!state.clientProfile) return;

      state.clientProfile = { ...state.clientProfile, ...action.payload };

      if (typeof window !== "undefined") {
        localStorage.setItem(
          "client_profile",
          JSON.stringify(state.clientProfile)
        );
      }
    },
  },
});

export const { setAuth, clearAuth, initializeAuth, updateProfile } =
  authSlice.actions;
export default authSlice.reducer;
